import { http, HttpResponse } from 'msw'

export const mockUpdateCustomerCustomField = http.patch(
  '/my-business/api/agency/v1/customers/custom-fields/:customFieldAlphaId',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 200 },
    )
  },
)
